import { Button, Radio, Typography } from "@mui/material";
import addPaymentMethod from "assets/images/add-payment-method.png";
import bankMethod from "assets/images/bank-transfer.png";
import upiMethodGooglePay from "assets/images/gpay.png";
import upiMethodPaytm from "assets/images/paytm.png";
import upiMethodPhonePe from "assets/images/phonepe.png";
import upiMethod from "assets/images/upi-method.png";
import MRow from "components/shared/MRow";
import { ConfigContext } from "context/ConfigContext";
import { useUserContext } from "context/UserContext";
import { useContext, useEffect } from "react";
import colors from "styles/colors";
import { groupBy } from "utils/array";
import { isEnabledForCurrentPlatform } from "utils/platforms";

const PaymentMethod = ({ method, onClick, currentMethod, background }) => {
  const configContext = useContext(ConfigContext);

  let successRate =
    configContext?.config?.messages?.payment_method?.success_rate ?? {};
  let defaultSelectedPaymentMethod =
    configContext?.config?.features?.payment_method?.default ?? null;
  const payment_icons = (methodName) => {
    switch (methodName) {
      case "upi_transfer":
        return [upiMethod];
      case "other_upi_intent":
        return [upiMethod];
      case "gpay_transfer":
      case "gpay_intent":
        return [upiMethodGooglePay];
      case "paytm_transfer":
      case "paytm_intent":
        return [upiMethodPaytm];
      case "phonepe_transfer":
      case "phonepe_intent":
        return [upiMethodPhonePe];
      case "bank_transfer":
      case "sepa_transfer":
      case "van_transfer":
        return [bankMethod];
      case "card_transfer":
        return [addPaymentMethod];
      default:
        return [upiMethod];
    }
  };

  let options = method?.options
  if (method.category_name == "UPI" && options) {
    const optionsByIntent = groupBy(method?.options, (option) => option.name.includes("intent") ? "intent" : "code-flow")
    const allowIntent = configContext?.config?.features?.payment_method?.allow_intent
      && isEnabledForCurrentPlatform(configContext?.config?.features?.payment_method?.intent?.platforms)
    options = allowIntent && optionsByIntent["intent"] && optionsByIntent["intent"].length > 0
      ? optionsByIntent["intent"] : optionsByIntent["code-flow"]
  }

  useEffect(() => {
    options?.map((option) => {
      if (option?.name === defaultSelectedPaymentMethod) {
        onClick(method.category_name, option?.name);
      }
    });
  }, []);

  const hasValidBankAccount = useUserContext()?.user?.hasValidBankAccount()

  return (
    <div>
      <div
        style={{
          width: "100%",
          flex: 1,
          display: "flex",
        }}
      >
        <Typography
          style={{ fontSize: 14, fontWeight: 600 }}
        >{`${method?.category_display_name}`}</Typography>
      </div>
      <div style={{ padding: "0px 10px 10px 10px" }}>
        {options?.map((option, index) => {
          return (
            <div
              key={index}
              style={{
                borderBottomWidth: index + 1 === options.length ? 0 : 1,
                borderColor: colors.Grey.borderGrey,
              }}
            >
              <Button
                key={index}
                onClick={() => {
                  onClick(method.category_name, option?.name);
                }}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  background: "#FFFFFF",
                  justifyContent: "flex-start",
                  borderBottomWidth:
                    index + 1 === options.length ? 0 : 1,
                  width: "100%",
                  borderColor: colors.Grey.borderGrey,
                  ...background,
                  padding: "4px 0px 4px 0px",
                  marginBottom: 4,
                  marginTop: 4,
                  paddingLeft: 0,
                  paddingRight: 0,
                }}
                sx={{
                  textTransform: "none !important",
                }}
              >
                <MRow
                  leftElement={
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <Radio
                        size="small"
                        checked={currentMethod === option?.name}
                        onChange={() => {
                          onClick(method.category_name, option?.name);
                        }}
                        value="b"
                        name="radio-buttons"
                        style={{ paddingLeft: 0 }}
                        inputProps={{ "aria-label": "B" }}
                      />
                      <div
                        style={{
                          lineHeight: "150%",
                          display: "flex",
                          alignItems: "flex-start",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          style={{
                            fontFamily: "Inter",
                            fontStyle: "normal",
                            fontWeight: "500",
                            fontSize: "15px",
                            lineHeight: "150%",
                            display: "flex",
                            alignItems: "center",
                            fontFeatureSettings:
                              "'cv01' on, 'cv08' on, 'cv05' on",
                            color: "black",
                          }}
                        >
                          {method.category_name === "VIRTUAL_ACCOUNT" && !hasValidBankAccount ? "Add Bank Account" : option?.display_name}
                        </Typography>
                        {successRate?.[option?.name] && <Typography variant="caption" color={colors.Grey.title}>
                          {successRate?.[option?.name]}
                        </Typography>}
                      </div>
                    </div>
                  }
                  rightElement={payment_icons(option?.name).map(
                    (image, index) => {
                      return (
                        <div
                          style={{
                            display: "flex", marginTop: 4,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          key={index}
                        >
                          <img
                            alt="payment-method"
                            style={{
                              height: 35,
                              borderWidth: 1,
                              borderColor: colors.Grey.borderGrey,
                              borderRadius: 6,
                            }}
                            src={image}
                          />
                        </div>
                      );
                    }
                  )}
                />
              </Button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PaymentMethod;
